<template>
  <section class="container content-padding">
    <privacy-th v-if="$i18n.locale === 'th'"/>
    <privacy-en v-else />
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import PrivacyTh from './PrivacyTh'
  import PrivacyEn from './PrivacyEn'

  export default {
    components: {
      PrivacyTh,
      PrivacyEn
    },
    data () {
      return {
        currentLanguage: this.$i18n.locale
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/information/Privacy.vue